import { isEmpty } from './validator'

export function getInterestOrNot(pricingType: string, interestOnly?: boolean) {
  let rlt = false

  if (!isEmpty(interestOnly)) return interestOnly

  try {
    if (pricingType.includes('I/O') || pricingType.includes('IO')) rlt = true
  } catch {}

  return rlt
}
